import { render, staticRenderFns } from "./GiroInfo.vue?vue&type=template&id=760b20cd&scoped=true"
import script from "./GiroInfo.vue?vue&type=script&lang=js"
export * from "./GiroInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b20cd",
  null
  
)

export default component.exports